(function () {
  const BP = 768;
  let original = null;

  function isMobileTablet() {
    return window.matchMedia(`(max-width:${BP}px)`).matches;
  }
  function getSlot() {
    return document.querySelector('[data-pdp-media-slot]');
  }
  function getMedia() {
    return document.querySelector('media-gallery') || document.querySelector('.media-gallery');
  }

  function moveMedia() {
    const slot = getSlot();
    const media = getMedia();
    if (!slot || !media) return;

    if (!original) original = { parent: media.parentNode, next: media.nextSibling };

    if (isMobileTablet()) {
      if (!slot.contains(media)) slot.appendChild(media);
    } else {
      if (original?.parent) {
        if (original.next) original.parent.insertBefore(media, original.next);
        else original.parent.appendChild(media);
      }
    }
  }

  function init() {
    moveMedia();
    // 再补一次，防止图片组件晚加载
    setTimeout(moveMedia, 600);

    // 只监听断点变化（不会因为拖动窗口触发上百次）
    const mq = window.matchMedia(`(max-width:${BP}px)`);
    const onChange = () => moveMedia();
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
  }

  document.addEventListener('DOMContentLoaded', init);
})();


(function () {
  // 1) 找到评论区（Judge.me）
  function getReviewsTarget() {
    return (
      document.querySelector('#judgeme_product_reviews') ||
      document.querySelector('#judgeme-product-reviews') ||
      document.querySelector('.jdgm-widget.jdgm-review-widget') ||
      document.querySelector('.jdgm-rev-wid')
    );
  }

  // 2) 判断是否点在“评分区域”（星星 + 16 reviews 所在块）
function isRatingAreaClick(target) {
  return !!target.closest(
    '.theme-productreviews, .cc-rating, .cc-rating-custom-caption, [data-pdp-rating-slot]'
  );
}


  // 3) 全局捕获监听：保证不被别的脚本抢走
  function onDocClick(e) {
    if (!isRatingAreaClick(e.target)) return;

    const reviews = getReviewsTarget();
    if (!reviews) return;

    e.preventDefault();
    e.stopPropagation();

    // 让 URL 有锚点（可选）
    try { history.replaceState(null, '', '#reviews'); } catch (err) {}

    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // 防重复绑定
  if (window.__pdpReviewJumpBound) return;
  window.__pdpReviewJumpBound = true;

  document.addEventListener('click', onDocClick, true); // true = capture
})();

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('back-to-top');
  if (!btn) return;

  window.addEventListener('scroll', () => {
    btn.style.display = window.scrollY > 400 ? 'block' : 'none';
  });

  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});
